<fieldset [formGroup]="skjema">
  <mat-select formControlName="forvalg" [compareWith]="erValgtForvalg" (openedChange)="nedtrekksmenyAapnet($event)" panelClass="velg-landprefiks--alternativer" panelWidth="null" placeholder="{{'landkode'|translate}}">
    @for (prefiks of tilgjengeligeForvalg; track prefiks.indeks) {
      <mat-option [value]="prefiks.nummer">{{ prefiks.navn }}</mat-option>
    }
   </mat-select>
  <input formControlName="nummer" name="nummer" (focus)="vedFokusMottatt()" (blur)="vedFokusMistet()" [placeholder]="placeholder" #mobilnummerfelt data-testid="mobilnummer-felt">
</fieldset>
